// hooks/market/useMarketAuth.ts
//
// Vérifie si l'utilisateur connecté a le rôle 'userpro', pour
// autoriser l'accès aux sections Market réservées aux vendeurs
// (créer boutique, publier produit, réglages d'apparence) dans
// reglages.tsx. Réutilise l'action 'get-profile' EXISTANTE de
// handleProfile.ts (route /profile) — pas de nouvel endpoint Market
// nécessaire, le rôle vit déjà sur profiles.role.

import { useState, useEffect, useCallback } from 'react';
import { API_BASE_URL } from '@/lib/api';
import { getValidToken } from '@/lib/auth';

export function useMarketAuth() {
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState<string | null>(null);

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = await getValidToken();
      if (!token) {
        setError('session_expired');
        return;
      }

      const res = await fetch(`${API_BASE_URL}/profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action:       'get-profile',
          access_token: token,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        setError(data.error || 'Impossible de charger le profil');
        return;
      }

      setRole(data.profile?.role ?? null);
    } catch (err) {
      console.error('[useMarketAuth]', err);
      setError('network_error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const isUserpro = role === 'userpro';

  return { role, isUserpro, loading, error };
}
